import { CharacterCounter } from '@/components/common/CharacterCounter';
import { FormControl } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import {
  SURVEY_ANSWER_DEFAULT_PLACEHOLDER,
  SURVEY_ANSWER_PLACEHOLDER_BY_ANSWER_TYPE,
} from '../../constants/survey.constants';
import type { SurveyQuestionDetail } from '../../types/survey.types';
import { isNumericTextQuestion } from '../../utils/surveyAnswerForm';

interface TextAnswerInputProps {
  question: SurveyQuestionDetail;
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  name: string;
  invalid: boolean;
}

export function TextAnswerInput({
  question,
  value,
  onChange,
  onBlur,
  name,
  invalid,
}: TextAnswerInputProps) {
  const isNumeric = isNumericTextQuestion(question);
  const placeholder = question.answerType
    ? SURVEY_ANSWER_PLACEHOLDER_BY_ANSWER_TYPE[question.answerType]
    : SURVEY_ANSWER_DEFAULT_PLACEHOLDER;

  if (isNumeric) {
    return (
      <FormControl>
        <Input
          name={name}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          onBlur={onBlur}
          inputMode="decimal"
          placeholder={placeholder}
          className="h-10"
          aria-invalid={invalid || undefined}
        />
      </FormControl>
    );
  }

  return (
    <div className="space-y-1.5">
      <FormControl>
        <Textarea
          name={name}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          onBlur={onBlur}
          rows={3}
          placeholder={placeholder}
          maxLength={question.maxChars ?? undefined}
          aria-invalid={invalid || undefined}
        />
      </FormControl>
      {question.maxChars !== null ? (
        <CharacterCounter current={value.length} max={question.maxChars} className="ml-auto" />
      ) : null}
    </div>
  );
}
